import React, { Component, Fragment } from 'react';
// import { profilePic } from '../../assets/images/pro1.jpg';
//import { Grid, Image } from 'semantic-ui-react'
import AlertContainer from 'react-alert';
import { UtilityService, CommunicationServices } from "../../services";

class Communication extends Component {
    constructor(props) {
        super(props);

    }
    alertOptions = {
        offset: 65,
        position: 'top left',
        theme: 'dark',
        time: 1000,
        transition: 'scale'
    }
    componentWillMount(){
        CommunicationServices.getAllInfo().then((response)=>{
            
        }).catch((error)=>{
            
            // UtilityService.errorMsg(this.msg)
        })
    }
    componentDidMount() {
        this.enableMultiSelect()
    }

    enableMultiSelect() {
        // $(document).ready(function () {
        //     $('#range-slct').multiselect();
        // });
    }

    render() {
        return (
            <Fragment>

            <div class="right-section">
                        <div class="row nopadding">
                            <div class="col-md-12">
                                <ul>
                                    <li><a href="#"></a></li>
                                    <li><h6>Communication</h6></li>
                                    <li class="pull-right"><a href="#"></a></li>
                                </ul>
                            </div>
                            <div class="col-md-12 nopadding">
                                    <div class="col-md-12 nopadding">
                                        <div class="card-container">
                                            <div class="row styles-select-con">
                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div class="col-md-12 style-card-con">
                                                    <a onClick = {()=> this.props.history.push("/chat")} style={{cursor:"pointer"}}>
                                                        <div class="style-card">
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <h6>Style 1</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Name ABSC</h6>
                                                                </div>
                                                                <div class="col-md-4">
                                                                    <h6>Cust Ref - 1002</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            </Fragment>
        );
    }
}

export default Communication;








// WEBPACK FOOTER //
// ./src/pages/communication/page.js